/* eslint-disable @typescript-eslint/indent */
import { hasOnlyDigits } from './utils';

/**
 * Sorts camp slots primarily by slotNumber and uses
 * slot property as a fallback. Returns sorted copy
 * and modifies not the original array.
 * @param ParkSlot[] campSlots
 * @returns sorted copy of campSlots array
 */
export const sortCampSlots = (campSlots: ParkSlot[]): ParkSlot[] => {
  if (!campSlots) return [];
  return [...campSlots].sort((campSlotA, campSlotB) => {
    // Currently two types of campSlot can be obtained from
    // backend as response. One contains data property and the another
    // does not. Let's take both into account in this sorting function so
    // it can be used many places.
    const slotA = campSlotA?.data?.slot ?? campSlotA.slot;
    const slotNumberA = campSlotA?.data?.slotNumber ?? campSlotA.slotNumber;
    const slotB = campSlotB?.data?.slot ?? campSlotB.slot;
    const slotNumberB = campSlotB?.data?.slotNumber ?? campSlotB.slotNumber;
    const numericSlotA = hasOnlyDigits(slotNumberA, false)
      ? Number(slotNumberA)
      : hasOnlyDigits(slotA, true)
      ? Number(slotA)
      : 0;
    const numericSlotB = hasOnlyDigits(slotNumberB, false)
      ? Number(slotNumberB)
      : hasOnlyDigits(slotB, true)
      ? Number(slotB)
      : 0;

    return numericSlotA - numericSlotB;
  });
};
